import { memo, useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router';
import enhancedNavigate from '../../utils/tools/enhancedNavigate';
import { useSettingsContext } from '../../context/settings';

type FahrzeugsucheProviderProps = {
    children: ReactNode;
}

function FahrzeugsucheProvider(props: FahrzeugsucheProviderProps) {
    const { children } = props;
    const navigate = useNavigate();
    const settings = useSettingsContext();

    useEffect(() => {
        if (!settings?.general?.useOldRouter) {
            const replaceState = globalThis?.history?.replaceState;
            const pushState = globalThis?.history?.pushState;

            if (replaceState) {
                history.replaceState = function (...args: any[]) {
                    const incomeState = args[0] ?? {};
                    const isInitiatedByNext = (incomeState.__N === true);
                    if (isInitiatedByNext) {
                        enhancedNavigate(args?.[2], navigate, true);
                    } else {
                        // @ts-expect-error
                        replaceState.call(history, ...args);
                    }
                };
            }
            if (pushState) {
                history.pushState = function (...args: any[]) {
                    const incomeState = args[0] ?? {};
                    const isInitiatedByNext = (incomeState.__N === true);
                    if (isInitiatedByNext) {
                        enhancedNavigate(args?.[2], navigate, false);
                    } else{
                        // @ts-expect-error
                        pushState.call(history, ...args);
                    }
                };
            }

            return () => {
                if (replaceState) {
                    history.replaceState = replaceState;
                }
                if (pushState) {
                    history.pushState = pushState;
                }
            };
        }
    }, [navigate, settings?.general?.useOldRouter]);

    return children;
}

export default memo(FahrzeugsucheProvider);
